import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-neutral-950">
      <div className="w-full px-4 md:px-8 lg:px-16 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/4412af0d-47c4-4fb9-a4d8-9e8f9cbf751a.png"
                alt="RESINVENCA Logo"
                className="h-20 md:h-32 w-auto object-contain select-none"
                draggable="false"
              />
            </div>
            <p className="text-neutral-400 text-sm leading-relaxed mb-5 max-w-xs text-justify">
              Importadores y distribuidores de demulsificantes ya formulados de Rixin Corp (China). 
              Producto puesto en Venezuela, listo para usar en la industria petrolera.
            </p>
            <div className="flex items-center gap-3">
              {[
                { icon: 'ri-linkedin-fill', href: '#' },
                { icon: 'ri-twitter-x-fill', href: '#' },
                { icon: 'ri-youtube-fill', href: '#' },
              ].map((social) => (
                <a
                  key={social.icon}
                  href={social.href}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-neutral-800 text-neutral-400 hover:bg-primary-500 hover:text-white transition-all duration-300 cursor-pointer"
                  rel="nofollow"
                >
                  <i className={`${social.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Enlaces rápidos */}
          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-5">
              Enlaces Rápidos
            </h4>
            <ul className="space-y-3">
              {[
                { label: 'Inicio', to: '/' },
                { label: 'Quiénes Somos', to: '/nosotros' },
                { label: 'Rixin Group', to: '/rixin' },
                { label: 'Productos', to: '/productos' },
                { label: 'Diferenciadores', to: '/diferenciadores' },
                { label: 'Contacto', to: '/contacto' },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-neutral-400 hover:text-white text-sm transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Producto y Campos */}
          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-5">Producto y Campos</h4>
            <ul className="space-y-3">
              <li>
                <span className="text-neutral-400 text-sm font-medium">Demulsificante para Crudo</span>
              </li>
              <li className="pt-1">
                <span className="inline-flex items-center gap-1.5 text-primary-400 text-xs font-medium">
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-shield-check-line text-xs"></i>
                  </div>
                  Importado de Rixin Corp, China
                </span>
              </li>
              <li className="pt-1">
                <span className="inline-flex items-center gap-1.5 text-primary-400 text-xs font-medium">
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-shield-check-line text-xs"></i>
                  </div>
                  Aprobado PDVSA
                </span>
              </li>
              <li className="pt-3">
                <span className="text-neutral-500 text-xs block mb-2">Campos aprobados:</span>
                {['Ayacucho', 'Carabobo', 'Junín', 'Boyacá'].map((campo) => (
                  <div key={campo} className="flex items-center gap-2 py-0.5">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-map-pin-line text-primary-500 text-xs"></i>
                    </div>
                    <span className="text-neutral-400 text-xs">{campo}</span>
                  </div>
                ))}
              </li>
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-5">Contacto</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-primary-400 text-sm"></i>
                </div>
                <span className="text-neutral-400 text-sm">Venezuela</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-phone-line text-primary-400 text-sm"></i>
                </div>
                <span className="text-neutral-400 text-sm">+58 412 101 9460</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-whatsapp-line text-primary-400 text-sm"></i>
                </div>
                <a
                  href="https://wa.me/584121019460"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-neutral-400 hover:text-primary-400 text-sm transition-colors duration-200 cursor-pointer"
                >
                  +58 412 101 9460
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-whatsapp-line text-primary-400 text-sm"></i>
                </div>
                <a
                  href="https://wa.me/584129080594"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-neutral-400 hover:text-primary-400 text-sm transition-colors duration-200 cursor-pointer"
                >
                  +58 412 908 0594
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line text-primary-400 text-sm"></i>
                </div>
                <div className="flex flex-col gap-0.5">
                  <span className="text-neutral-400 text-sm">info@resinvenca.com</span>
                  <span className="text-neutral-400 text-sm">ventas@resinvenca.com</span>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-time-line text-primary-400 text-sm"></i>
                </div>
                <span className="text-neutral-400 text-sm">Lun - Vie: 8:00 AM - 5:00 PM</span>
              </li>
            </ul>

            <div className="flex items-center gap-3 mt-6 pt-5 border-t border-neutral-800">
              <a
                href="https://www.instagram.com/resinvenca29chemicals"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-neutral-800 text-neutral-400 hover:bg-primary-500 hover:text-white transition-all duration-300 cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-fill text-sm"></i>
              </a>
              <a
                href="https://wa.me/584129080594"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-neutral-800 text-neutral-400 hover:bg-green-500 hover:text-white transition-all duration-300 cursor-pointer"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-fill text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-neutral-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-neutral-500 text-xs">
            &copy; {currentYear} RESINVENCA RESINAS DE VENEZUELA C.A. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-neutral-500 hover:text-neutral-300 text-xs transition-colors cursor-pointer">Política de Privacidad</a>
            <a href="#" className="text-neutral-500 hover:text-neutral-300 text-xs transition-colors cursor-pointer">Términos de Servicio</a>
          </div>
        </div>
      </div>
    </footer>
  );
}